import api from '../api';

const routes = require('routes.js.erb');

const getConfiguration = function({ commit }, name) {
  return api.get(routes.api_v5_dropper_configuration_path(name));
}

export { getConfiguration };